export default "# <i class=\"mdi mdi-lifebuoy theme--dark primary--text \"></i> Support\n\n[Hier können Sie die Support Quellen für die Software einfügen...]\n"